// extracted by mini-css-extract-plugin
module.exports = {"badgeStatus":"atoms_badgeStatus__3vRsH"};